module.exports = __webpack_public_path__ + "img/next-icon.edf4d914.svg";